import React from 'react'
import { DateRangePicker } from 'components/DatePickerStyled/DateRangePicker'
import Label from 'components/Form/Label'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'
import moment from 'moment'

const PostedOnFilter = ({ postedDate, setPostedDate }) => {
  const dateFormat = 'DD/MM/YYYY'

  const onPostedChange = (value, date) => {
    const parsedDates = date.map(d => moment(d, 'DD/MM/YYYY'))
    const formattedDates = parsedDates.map(d =>
      d?.isValid() ? d?.format('YYYY-MM-DD') : null
    )
    setPostedDate({
      postedStart: formattedDates[0],
      postedEnd: formattedDates[1],
    })
  }

  const disablePreviousDate = current => {
    return current && current > moment().endOf('day')
  }

  return (
    <Wrapper column>
      <Label>Select Date *</Label>
      <DateRangePicker
        placeholder={[dateFormat, dateFormat]}
        picker={'date'}
        width="100%"
        onChange={onPostedChange}
        format={dateFormat}
        defaultValue={
          Object.values(postedDate).filter(item => item).length
            ? [
                moment(postedDate?.postedStart, dateFormat),
                moment(postedDate?.postedEnd, dateFormat),
              ]
            : ['', '']
        }
        disabledDate={disablePreviousDate}
      />
    </Wrapper>
  )
}

export default PostedOnFilter
